import {
  SET_CHAT_SCHEDULES,
  SET_CHAT_REQUESTS,
  SET_CHAT_MEETINGS,
  SET_CHAT_USER,
  SET_USERS_MESSAGES,
  SET_CHAT_CATEGORY_OPEN,
  SET_CHAT_MEETING_DATA,
  SET_CHAT_MEETING_NOTIFICATIONS,
  SET_LAST_MESSAGE_ID,
  SET_UPDATE_MESSAGE,
  SET_IS_MOBILE,
  SET_GET_CHATS,
  SET_CHAT_NOTIFICATION,
  SET_USER_FROM_ID,
} from './constants'

export const setChatSchedulesAction = payload => ({ type: SET_CHAT_SCHEDULES, payload })
export const setChatRequestsAction = payload => ({ type: SET_CHAT_REQUESTS, payload })
export const setChatMeetingsAction = payload => ({ type: SET_CHAT_MEETINGS, payload })
export const setChatUserAction = payload => ({ type: SET_CHAT_USER, payload })
export const setUsersMessagesAction = payload => ({ type: SET_USERS_MESSAGES, payload })
export const setChatCategoryOpenAction = payload => ({ type: SET_CHAT_CATEGORY_OPEN, payload })
export const setMeetingAction = payload => ({ type: SET_CHAT_MEETING_DATA, payload })
export const setMeetingNotificationsAction = payload => ({ type: SET_CHAT_MEETING_NOTIFICATIONS, payload })
export const setLasstMessageIdAction = payload => ({ type: SET_LAST_MESSAGE_ID, payload })
export const setUpdateMessageAction = payload => ({ type: SET_UPDATE_MESSAGE, payload })
export const setIsMobileAction = payload => ({ type: SET_IS_MOBILE, payload })
export const setGetChatsAction = payload => ({ type: SET_GET_CHATS, payload })
export const setChatNotificationAction = payload => ({ type: SET_CHAT_NOTIFICATION, payload })
export const setUserFromIdAction = payload => ({ type: SET_USER_FROM_ID, payload })

export const setChatSchedules = data => dispatch => dispatch(setChatSchedulesAction(data))
export const setChatRequests = data => dispatch => dispatch(setChatRequestsAction(data))
export const setChatMeetings = data => dispatch => dispatch(setChatMeetingsAction(data))
export const setChatUser = data => dispatch => dispatch(setChatUserAction(data))
export const setUsersMessages = data => dispatch => dispatch(setUsersMessagesAction(data))
export const setChatCategoryOpen = data => dispatch => dispatch(setChatCategoryOpenAction(data))
export const setMeeting = data => dispatch => dispatch(setMeetingAction(data))
export const setMeetingNotifications = data => dispatch => dispatch(setMeetingNotificationsAction(data))
export const setLasstMessageId = data => dispatch => dispatch(setLasstMessageIdAction(data))
export const setUpdateMessage = data => dispatch => dispatch(setUpdateMessageAction(data))
export const setIsMobile = data => dispatch => dispatch(setIsMobileAction(data))
export const setGetChats = data => dispatch => dispatch(setGetChatsAction(data))
export const setChatNotification = data => dispatch => dispatch(setChatNotificationAction(data))
export const setUserFromId = data => dispatch => dispatch(setUserFromIdAction(data))
